import { useState } from "react";
import { useNavigate } from "react-router-dom";

import Button from "../../components/Button";
import Input from "../../components/Input";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { forgotPasswordSchema } from "./schemas/authenticationSchema";

import { sendResetPassword } from "../../api/authRequest";
import { useTranslation } from "../../i18n/TranslationProvider";

const ForgotPassword = () => {
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm({
        resolver: yupResolver(forgotPasswordSchema),
    });

    const onSubmit = async (data) => {
        setError("");

        try {
            await sendResetPassword(data);
            setSuccess(true);
        } catch (err) {
            console.error("Error sending password reset email:", err);
            if (err.response?.status === 404) {
                setError(t("auth.forgotPasswordErrorNotFound"));
            } else {
                setError(t("auth.forgotPasswordErrorGeneric"));
            }
        }
    };

    return (
        <>
            <div className="custom-container mx-auto w-4/5 lg:w-1/2">
                <div className="text-base md:text-2xl text-center mx-auto mb-2">
                    <h4 className="mb-2">{t("auth.forgotPasswordHeading")}</h4>
                    <p>{t("auth.forgotPasswordSubheading")}</p>
                </div>
                <form
                    className="flex flex-col gap-4"
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <Input
                        label={t("auth.email")}
                        name="email"
                        register={register}
                        errors={errors}
                        placeholder={t("auth.emailPlaceholder")}
                    />
                    {error && <p className="text-red-600">{error}</p>}
                    {success && !error && (
                        <p className="text-teal-600 font-semibold">
                            {t("auth.forgotPasswordSuccess")}
                        </p>
                    )}
                    <Button type="submit" isLoading={isSubmitting}>
                        {t("auth.sendResetLink")}
                    </Button>
                </form>
                <Button
                    className="mt-4"
                    onClick={() => navigate("/login")}
                    variant="outline"
                >
                    {t("auth.back")}
                </Button>
                <div className="mt-4 px-2 flex justify-between items-center">
                    <p>{t("auth.needHelp")}</p>
                    <h6
                        className="text-teal-600 cursor-pointer"
                        onClick={() => navigate("/help")}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                navigate("/help");
                            }
                        }}
                    >
                        {t("auth.contactUs")}
                    </h6>
                </div>
            </div>
        </>
    );
};

export default ForgotPassword;